import { useEffect, useRef } from "react";
import i18n from "./i18n";
import { useLanguageStore } from "../store/langStore";
import { queryClient } from "../services/tanStackClient";

export function LanguageSync() {
  const appLang = useLanguageStore((state) => state.appLang);

  useEffect(() => {
    if (i18n.language !== appLang) {
      i18n.changeLanguage(appLang);
    }
  }, [appLang]);

  const didInit = useRef(false);
  useEffect(() => {
    if (!didInit.current) {
      didInit.current = true;
      return;
    }
    // queryClient.invalidateQueries();
  }, [appLang]);

  return null;
}
